<script>
export default {
  name: "loadMore",

  methods: {
    loadMore() {
      console.log("load more in load more component");
      this.$emit("loadMoreFunction");
      //this.pageSize = this.pageSize=this.pageSize + 8
      // this.filterList()
    }
  }
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #ffffff">
    <el-col
      :span="24"
      style="display: flex; justify-content: center; padding: 0 16px"
    >
      <el-button class="btn-load-more" type="primary" @click="loadMore">
        Load more
      </el-button>
    </el-col>
  </el-row>
</template>

<style scoped>
.btn-load-more {
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  width: 100%;
  padding: 14px 0;
  font: 600 20px Metropolis, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/search/loadMore.vue